import React from 'react';
import PropTypes from 'prop-types';
import {Glyphicon} from 'react-bootstrap';

class Collapsible extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            isExpanded : false,
            hasEditFeature: props.hasEditFeature,
            hasDeleteFeature: props.hasDeleteFeature
        }
        this.onEditClick = this.onEditClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
    }

    onEditClick(e){
        e.preventDefault();
        if(this.state.hasEditFeature){
            this.props.onEditClick(this.props.user);
        }
    }

    onDeleteClick(e){
        e.preventDefault();
        if(this.state.hasDeleteFeature){
            this.props.onDeleteClick(this.props.user);
        }
    }

    handleToggle(e){
        e.preventDefault();
        if( e.target.title !== 'Edit'){
            this.setState({
                isExpanded: !this.state.isExpanded,
                height: this.refs.inner.clientHeight
            });
        }
    }

    render(){
        const {title, children} = this.props;
        const {isExpanded, height} = this.state;
        const currentHeight = isExpanded ? height : 0;
        return (
            <div className={`panel ${isExpanded ? 'is-expanded' : ''}`} onClick={this.handleToggle}>
                <div className="panel-heading">
                    <h2>{title}</h2>
                    <Glyphicon title="Expand / Collapse" glyph={`${isExpanded ? "chevron-up" : "chevron-down"}`} onClick={this.handleToggle} style={{float: "right", position: "relative", top: "-25px"}}/>
                    {
                        this.state.hasEditFeature && 
                        <Glyphicon title="Edit" glyph="pencil" onClick={this.onEditClick} style={{float: "right", position: "relative", top: "-25px", paddingRight: "20px"}}/>
                    }
                    {
                        this.state.hasDeleteFeature && 
                        <Glyphicon title="Delete" glyph="trash" onClick={this.onDeleteClick} style={{float: "right", position: "relative", top: "-25px", paddingRight: "20px"}}/>
                    }
                </div>
                <div className="panel-collapse" style={{height: currentHeight+'px'}}>
                    <div className="panel-body" ref="inner">
                        {children}
                    </div>
                </div>
            </div>
        )
    }

}

Collapsible.propTypes = {
    title: PropTypes.string,
};

export default Collapsible;


// WEBPACK FOOTER //
// ./src/js/Collapsible.js